import '@babel/polyfill';
import Vue from 'vue';
import Amplify, * as AmplifyModules from 'aws-amplify';

import i18n from '@/mixins/i18n';
import vuetify from '@/mixins/vuetify';
import aws_exports from '@/aws-exports';

Amplify.configure(aws_exports);
Vue.use(AmplifyModules);
Vue.config.productionTip = false;

import router from '@/router';
import App from '@/components/App';

// Initialize the Vue instance attaching the vuetify instance, the defined 
// router and the plugin to support locales.
new Vue({
    vuetify,
    router,
    i18n,
    render: h => h(App)
}).$mount('#app');
